import React from "react";
import { Card, Button } from "react-bootstrap";
import { FaGamepad, FaRegHandPointRight } from "react-icons/fa";
import { IoMdPodium } from "react-icons/io";
import { formatCurrency } from "../../../utils/utils";

interface BudgetModeRulesCardProps {
	numberOfMen: number;
	numberOfWomen: number;
	budget: number;
	setViewScoring: (value: boolean) => void;
}

const BudgetModeRulesCard: React.FC<BudgetModeRulesCardProps> = ({
	numberOfMen,
	numberOfWomen,
	budget,
	setViewScoring,
}) => {
	return (
		<Card className="mb-3 shadow bg-secondary text-white border-0">
			<Card.Header className="fs-3 fw-bold">
				<FaGamepad className="me-2 mb-1 fs-4" />
				Budget Mode
			</Card.Header>
			<Card.Body style={{ fontSize: "0.8rem" }}>
				<Card.Text>
					<FaRegHandPointRight className="me-2" />
					Select {numberOfMen} Men, and {numberOfWomen} Women while staying
					within a budget of{" "}
					<span className="fw-bold">{formatCurrency(budget)}</span>.
				</Card.Text>
				<Card.Text>
					<FaRegHandPointRight className="me-2" />
					Select one World Cup Team.
				</Card.Text>
				<Card.Text>
					<FaRegHandPointRight className="me-2" />
					Points are awarded based on the performance of your selected athletes
					at events, combined with the points earned by your chosen team. (See
					the points structure below for details).
				</Card.Text>

				<div className="d-flex flex-row  justify-content-center">
					<Button variant="dark" size="sm" onClick={() => setViewScoring(true)}>
						<IoMdPodium className="mb-1 me-2" />
						Points Structure
					</Button>
				</div>
			</Card.Body>
		</Card>
	);
};

export default BudgetModeRulesCard;
